exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".CommitmentLayout-main-h5fI6 h4{margin:30px 20px;text-transform:uppercase;text-align:center;color:#546d79}.CommitmentLayout-main-h5fI6 h4 span{display:inline-block;height:24px;line-height:24px;vertical-align:bottom}.CommitmentLayout-main-h5fI6 h4 button{padding:0 10px}.CommitmentLayout-side-3bBqR h4{margin:30px 20px;text-transform:uppercase;text-align:center;color:#546d79}.CommitmentLayout-activityGroup-1w0TQ{margin:0;padding:0;list-style-type:none}.CommitmentLayout-activityGroup-1w0TQ>li{padding:10px 0;border-bottom:1px solid #dadada}", ""]);

// exports
exports.locals = {
	"main": "CommitmentLayout-main-h5fI6",
	"side": "CommitmentLayout-side-3bBqR",
	"activityGroup": "CommitmentLayout-activityGroup-1w0TQ"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?localIdentName=[name]-[local]-[hash:base64:5]!./~/autoprefixer-loader!./~/less-loader!./lib/provider/components/CommitmentLayout.less
// module id = 1703
// module chunks = 0